import { inputToTags, tagsToInput } from "../../mst/kinds/utils";
import { OptimisticConcurrency } from "../../schema/types/base";
import { Image } from "../../schema/types/image/entity";
import { ImageInput } from "../../schema/types/image/input";

export function getDefaultImageInput(): ImageInput {
  return {
    id: "",
    version: 0,
    tags: [],
    meta: {
      isEdit: false,
    },
  };
}

export function inputToImage(input: ImageInput): { tags: Record<string, any> } {
  return {
    tags: inputToTags(input.tags),
  };
}

export function imageToInput(image: Image): ImageInput {
  const def = getDefaultImageInput();
  const res: ImageInput = {
    ...def,
    id: image.id,
    version: image.version,
    tags: tagsToInput(image.tags),
    meta: {
      ...def.meta,
      isEdit: true,
    },
  };
  return res;
}

export function imageToPatch(_image: { tags: Record<string, any> }, concurrency: OptimisticConcurrency) {
  const image: any = JSON.parse(JSON.stringify(_image));

  image[`$replace/tags`] = image.tags;
  delete image.tags;

  image.id = concurrency.id;
  image.version = concurrency.version;

  return image;
}
